/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InfoDto
 */
export interface InfoDto {
    /**
     * 
     * @type {number}
     * @memberof InfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InfoDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoDto
     */
    imageUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoDto
     */
    link?: string | null;
}

/**
 * Check if a given object implements the InfoDto interface.
 */
export function instanceOfInfoDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InfoDtoFromJSON(json: any): InfoDto {
    return InfoDtoFromJSONTyped(json, false);
}

export function InfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'imageUrl': !exists(json, 'imageUrl') ? undefined : json['imageUrl'],
        'link': !exists(json, 'link') ? undefined : json['link'],
    };
}

export function InfoDtoToJSON(value?: InfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
        'imageUrl': value.imageUrl,
        'link': value.link,
    };
}

